import { useEffect } from 'react';
import { formatDateTimeRangeFromString } from '../../../../helpers/date-time';
import { useQueryParams } from '../../../../hooks/use-query-params';
import { DashboardCardType, FetchDashboardCardsRequest } from '../../../../store/api/dashboard-api';
import { useDashboardStore } from '../../../../store/use-dashboard-store';

export const useFetchDashboardCards = (cardType: DashboardCardType) => {
  const { fetchDashboardCards, cards } = useDashboardStore();

  const params = useQueryParams().getQueryParams();
  const range = params.range ? JSON.parse(params.range) : null;
  const to = range?.to;
  const from = range?.from;
  const branchId = params.branch;

  useEffect(() => {
    if (!branchId) {
      return;
    }

    const formatted = formatDateTimeRangeFromString(JSON.stringify({ from, to }));

    const params: FetchDashboardCardsRequest = {
      type: cardType,
      to: formatted?.to,
      branch: branchId,
      from: formatted?.from,
    };

    fetchDashboardCards(params);
  }, [from, to, branchId]);

  return { cards };
};
